var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDeposits16X16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29321",
    "data-name": "Group 29321",
    transform: "translate(-66.994 -78.833)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48490",
    "data-name": "Path 48490",
    d: "M68.027,85.6a1,1,0,0,0,0,2h2.05a6.37,6.37,0,0,1,.715-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491",
    "data-name": "Path 48491",
    d: "M74.78,82.008H70.708a1,1,0,0,0,0,2h1.16A6.346,6.346,0,0,1,74.78,82.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491-2",
    "data-name": "Path 48491",
    d: "M82.02,84.007h0a1,1,0,0,0,0-2H78.489A5.646,5.646,0,0,1,82.02,84.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48493",
    "data-name": "Path 48493",
    d: "M68.027,78.833a1.015,1.015,0,0,0,0,2.028H78.045a1.015,1.015,0,0,0,0-2.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48494",
    "data-name": "Path 48494",
    d: "M70,89.209H68.027a1,1,0,0,0,0,2h2.448A4.572,4.572,0,0,1,70,89.209Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48495",
    "data-name": "Path 48495",
    d: "M68.027,94.832H73A6.408,6.408,0,0,1,71.1,92.8H68.027a1.015,1.015,0,0,0-.06,2.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M82.966,88.321a5.551,5.551,0,0,0-3.086-4.443,5.823,5.823,0,0,0-7.719,2.392,5.6,5.6,0,0,0-.606,2.051,5.147,5.147,0,0,0-.016.795,5.567,5.567,0,0,0,.622,2.257l.123.214c.024.032.04.072.065.112.049.079.106.159.155.239.049.064.091.127.139.19l.033.04a5.788,5.788,0,0,0,2.856,1.963l.033.009a2.138,2.138,0,0,0,.221.063l.131.032a1.627,1.627,0,0,0,.181.04c.107.024.2.039.311.055a.65.65,0,0,1,.123.017l.254.023.114.008c.115.008.238.008.362.008s.238,0,.361-.008l.115-.008.246-.023a.628.628,0,0,1,.123-.017c.106-.016.213-.031.311-.055.065-.017.123-.024.188-.04l.131-.032a2.139,2.139,0,0,0,.221-.063l.033-.009a5.766,5.766,0,0,0,2.848-1.963l.032-.04c.041-.063.091-.126.14-.19.048-.08.106-.159.155-.239.024-.04.041-.079.065-.112l.123-.214a5.46,5.46,0,0,0,.633-2.257A5.277,5.277,0,0,0,82.966,88.321ZM78.726,90.9a1.847,1.847,0,0,1-1.007.429V92.3h-.813v-.953a2.927,2.927,0,0,1-.827-.119c-.181-.056-.352-.119-.524-.191L75.49,91l.246-.731.082.039a4.424,4.424,0,0,0,.548.2,3.048,3.048,0,0,0,.761.08,1.412,1.412,0,0,0,.795-.175.487.487,0,0,0,.2-.4.5.5,0,0,0-.091-.318,1.2,1.2,0,0,0-.253-.239,3.789,3.789,0,0,0-.385-.2c-.156-.064-.319-.12-.467-.166-.123-.048-.246-.1-.361-.144l-.115-.047a2.355,2.355,0,0,1-.426-.262,1.171,1.171,0,0,1-.31-.382,1.059,1.059,0,0,1-.123-.549,1.259,1.259,0,0,1,.361-.937,1.644,1.644,0,0,1,.934-.445v-.9H77.7v.85a4.618,4.618,0,0,1,.573.08c.221.056.385.1.474.135l.082.023-.2.755-.09-.032c-.147-.047-.3-.1-.458-.135a3.229,3.229,0,0,0-.672-.071,1.3,1.3,0,0,0-.671.16.482.482,0,0,0-.213.421.453.453,0,0,0,.065.254.473.473,0,0,0,.188.191,2.016,2.016,0,0,0,.319.167c.065.023.139.055.213.079s.139.048.213.079c.205.072.393.159.581.239a1.941,1.941,0,0,1,.492.3,1.308,1.308,0,0,1,.352.437,1.2,1.2,0,0,1,.131.6,1.255,1.255,0,0,1-.36.941Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDeposits16X16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_deposits16x16.3f1b503802665a42a35ad9182160af2d.svg";